import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { DataFlowDatasetSettings } from './dataset-settings/dataflow-dataset-settings';
import { SingleStreamOutputTransformation } from './single-output-stream.transformation';
import { LinkedService } from 'shell-models-lib';
import { DataFlowExpression } from 'app/model/dataflow/dataflowexpression';

@Metamodel.model({
    name: 'connect',
    display: [stringResources.DataFlowConnectTransformationLabel, stringResources.DataFlowConnectTransformationsLabel],
    referable: true,
    constraints: {
        name: {
            required: true
        }
    }
})
export class ConnectTransformation extends SingleStreamOutputTransformation {
    public static readonly MODEL: IModel;

    public datasetSettings: DataFlowDatasetSettings;
    public linkedService: LinkedService;

    // for dynamic generated connector
    public propertyMap: Map<string, DataFlowExpression> = new Map<string, DataFlowExpression>();

    public constructor() {
        super();
    }

    protected getGeneratedDescription(): string {
        // TODO: implement generated description
        return '';
    }
}
